export default "__VITE_ASSET__Bp7yvW0a__"